<template>
  <v-card height="auto" color="#EEEE">
    <v-container>
      <v-row dense>
        <v-col cols="12">
          <v-card-title>
            <h2 class="primary--text">Conoce nuestros casos de éxito</h2>
          </v-card-title>

          <v-divider class="mx-4 my-2"></v-divider>

          <v-img
            class="mx-2"
            width="auto"
            src="https://www.risoul.com.mx/hubfs/art-766.jpg"
          />

          <p
            class="mx-4 mt-2 text-xs-h5 text-sm-h5 text-md-h6 text-lg-h5 text-xl-h3"
          >
            Se busca cubrir la necesidad de acondicionar nuevas celdas robóticas
            de soldadura por arco sumergido con una fuente de voltaje directa
            constante con corriente variable.
          </p>

          <v-btn
            x-large
            elevation="10"
            class="white--text mx-4 mb-2"
            color="orange darken-3"
            @click="goToURL()"
          >
            <div class="text-md-h4">Leer más</div>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "child_ProductDetailBaner",

  components: {},

  data() {
    return {
      title: "",
    };
  },

  props: {},

  methods: {
    goToURL: function () {
      window.open(
        "https://www.risoul.com.mx/soluciones/redes-industriales/casos-de-exito"
      );
    },
  },

  computed: {},

  watch: {},

  created: function () {},

  mounted() {},
};
</script>

<style>
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
